import './app';
import './components/_components';
import './common/commonFns';
import './globals';